import { Routes, Route } from "react-router-dom";
import {
  DAY_GRAPH_REPORT,
  TIME_WISE_GRAPH_REPORTS,
  TIME_WISE_SUMMARY_REPORTS,
  DAY_SUMMARY_REPORT,
  OPERATOR_SUMMARY_REPORT,
  OPERATOR_DETAIL_REPORT,
  PART_DETAIL_REPORT,
  PART_SUMMARY_REPORT,
  PERFORMANCE_REPORT,
  BREAKDOWN_REPORT,
  TIME_WISE_MULTIDAY_REPORTS,
  DAY_MULTIDAY_REPORTS,
  BREAKDOWN_ANALYSIS,
  PNL_SUMMARY_REPORTS,
} from "../constants/routes";
import TimeGraphReportScreen from "../screens/TimeGraphReportScreen";
import TimeSummaryReportsScreen from "../screens/TimeSummaryReportsScreen";

import DayGraphReportsScreen from "../screens/DayGraphReportsScreen";
import DaySummaryReportScreen from "../screens/DaySummaryReportScreen";

import OperatorDetailReportScreen from "../screens/OperatorDetailReportScreen";
import OperatorSummaryReportScreen from "../screens/OperatorSummaryReportScreen";

import PartDetailReportScreen from "../screens/PartDetailReportScreen";
import PartSummaryReportScreen from "../screens/PartSummaryReportScreen.js";

import PerformanceReportScreen from "../screens/PerformanceReportScreen";
import BreakdownReportScreen from "../screens/BreakdownReportScreen/index.js";
import BreakDownAnalysisScreen from "../screens/BreakDownAnalysisScreen/index.js";
import DayDetailReportScreen from "../screens/DayDetailReportScreen/index.js";
import PnlManagerWiseReportsScreen from "../screens/PnlManagerWiseReportsScreen/index.js";

export default function ReportRouter() {
  return (
    <Routes>
          <Route
        path={PNL_SUMMARY_REPORTS}
        element={<PnlManagerWiseReportsScreen />}
      />
      <Route
        path={TIME_WISE_GRAPH_REPORTS}
        element={<TimeGraphReportScreen />}
      />
      <Route
        path={TIME_WISE_SUMMARY_REPORTS}
        element={<TimeSummaryReportsScreen />}
      />
      <Route
        path={TIME_WISE_MULTIDAY_REPORTS}
        element={<DayDetailReportScreen isSameDay={false} />}
      />

      <Route path={DAY_GRAPH_REPORT} element={<DayGraphReportsScreen />} />
      <Route path={DAY_SUMMARY_REPORT} element={<DaySummaryReportScreen />} />
      <Route
        path={DAY_MULTIDAY_REPORTS}
        element={<DayDetailReportScreen isSameDay={true} />}
      />

      <Route
        path={OPERATOR_SUMMARY_REPORT}
        element={<OperatorSummaryReportScreen />}
      />
      <Route
        path={OPERATOR_DETAIL_REPORT}
        element={<OperatorDetailReportScreen />}
      />

      <Route path={PART_SUMMARY_REPORT} element={<PartSummaryReportScreen />} />
      <Route path={PART_DETAIL_REPORT} element={<PartDetailReportScreen />} />
      <Route path={PERFORMANCE_REPORT} element={<PerformanceReportScreen />} />
      <Route path={BREAKDOWN_REPORT} element={<BreakdownReportScreen />} />
      <Route path={BREAKDOWN_ANALYSIS} element={<BreakDownAnalysisScreen />} />
    </Routes>
  );
}
